import { SliceZone } from "@prismicio/react"
import React from "react"

import { Layout } from "@/components/Partner/Layout/Layout"
import type { FormattedPartnerLandingPage } from "@/libs/prismic/types"
import { useUrl } from "@/libs/router"
import { components } from "@/slices"

export type LandingPageScreenProps = {
  landingPage: FormattedPartnerLandingPage
}

const LandingPageScreen = ({ landingPage }: LandingPageScreenProps) => {
  const { absolutePath } = useUrl()
  const { meta_title, meta_description, slices } = landingPage

  return (
    <Layout
      headProps={{
        url: absolutePath,
        title: meta_title,
        description: meta_description,
      }}>
      <div className="flex w-full flex-col gap-y-section pb-section">
        <SliceZone slices={slices} components={components} />
      </div>
    </Layout>
  )
}

export default LandingPageScreen
